import React from 'react';
import PropTypes from 'prop-types';
import ErrorIcon from '../../assets/images/icon_error_messages.gif';
import EN from '../../EN.json';
import FR from '../../FR.json';

const Header = ({ error }) => {
  const locale = localStorage.getItem('locale');
  const {
    USERS: {
      USER_AUTHENTICATION: {
        labels: { REGISTRATION_INFO_HEADING, REGISTRATION_INFO_FILL_DETAIL },
        ERRORS_MESSAGES: { GENERIC_ERROR_HEADING }
      }
    }
  } = locale === 'FR' ? FR : EN;

  return (
    <>
      <div id="main-content-title">
        <span
          className="frg-icon icon-user-profile-inverted"
          style={{ paddingRight: 10, fontSize: 26 }}
        />
        {REGISTRATION_INFO_HEADING}
      </div>
      <div id="main-content-steps">
        <h1>{REGISTRATION_INFO_FILL_DETAIL}</h1>
      </div>
      {error && (
        <div id="error-message-content" style={{ display: 'block' }}>
          <div id="error-message-icon">
            <img src={ErrorIcon} alt="error_icon" />
          </div>
          <div id="error-message-title">
            <span className="frg-body-font-23px">{GENERIC_ERROR_HEADING}</span>
          </div>
          <div className="clear" />
          <div id="error-message-message">
            <span className="frg-body-font-14px">
              {error}
              <br />
            </span>
          </div>
        </div>
      )}
    </>
  );
};

Header.propTypes = {
  error: PropTypes.bool
};

Header.defaultProps = {
  error: null
};

export default Header;
